import { UniDriver } from '@wix/unidriver-core';

export {
  isClassExists,
  makeControlled,
} from '@wix/wix-ui-test-utils/react-helpers';

export const findBaseByHook = (base: UniDriver, hook: string) =>
  base.$(`[data-hook*="${hook}"]`);
export const findBaseByExactHook = (base: UniDriver, hook: string) =>
  base.$(`[data-hook="${hook}"]`);

export const findByHook = (element: Element, hook: string) =>
  element.querySelector(`[data-hook*="${hook}"]`);

export const resolveIn = (timeout: number) =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve({});
    }, timeout);
  });

export const ASSET_PREFIX = 'http://localhost:3000/';

/**
 * Formatting all your dataHooks object properties to their query syntax ie. `[data-hook="${value}"]`
 */
export const getFormattedDataHooks = <T extends { [x: string]: string }>(
  dataHooks: T,
): Record<keyof T, string> => {
  const formattedDataHooks: Record<string, string> = {};
  Object.entries(dataHooks).map(
    ([entry, value]) => (formattedDataHooks[entry] = `[data-hook="${value}"]`),
  );
  return formattedDataHooks as Record<keyof T, string>;
};
